import { render, staticRenderFns } from "./SecondaryChildNavItem.vue?vue&type=template&id=6cfe58b6&scoped=true&"
import script from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryChildNavItem.vue?vue&type=style&index=0&id=6cfe58b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe58b6",
  null
  
)

export default component.exports